import { useEffect } from "react";
import { useLazyQuery } from "@apollo/client";
import { GET_STRUCTURE } from "./graphql/structure";
import { GlobalStore } from "../stores/global";

export default function StoreManager() {
  const { currentCountryCode } = GlobalStore.useState(s => s);
  const [loadStructure, { data }] = useLazyQuery(GET_STRUCTURE);

  /**** At this stage this component must rely on the value of currentCountryCode set by the geolocation service ****/

  useEffect(() => {
    if (currentCountryCode) loadStructure({ variables: { countryCode: currentCountryCode } });
  }, [loadStructure, currentCountryCode]);

  useEffect(() => {
    if (data) {
      GlobalStore.update(s => {
        s.config = data.config;
        s.countries = data.countries;
        s.structure = data;
        s.meta = data.heroes[0].meta;
        s.title = data.heroes[0].title;
        s.header = data.heroes[0].content[0];
        s.currentCountry = data.countries.find(c => c.twoLetterCode === currentCountryCode);
      });
    }
  }, [data, currentCountryCode]);

  return null;
}
